import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div>
              <Link to="/" className="inline-block cursor-pointer">
                <span className="font-heading text-2xl md:text-3xl font-bold text-white">AllChinaBuy Sheet</span>
              </Link>
              <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-xs">
                Your trusted resource for the best AllChinaBuy spreadsheet — verified sellers, updated product links, and comprehensive buying guides.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">Quick Links</h4>
              <div className="space-y-2.5">
                <Link to="/" className="block text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Home</Link>
                <Link to="/allchinabuy-spreadsheet-guide" className="block text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Shopping Guide</Link>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Main Website</a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">Popular Categories</h4>
              <div className="space-y-2.5">
                {categories.slice(0, 7).map((cat) => (
                  <a key={cat.name} href={cat.url} target="_blank" rel="noopener nofollow" className="block text-sm text-white/70 hover:text-white transition-colors cursor-pointer">{cat.name}</a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">Latest Articles</h4>
              <div className="space-y-2.5">
                {articles.slice(0, 5).map((a) => (
                  <Link key={a.slug} to={`/article/${a.slug}`} className="block text-sm text-white/70 hover:text-white transition-colors cursor-pointer truncate">
                    {a.title.length > 38 ? a.title.slice(0, 38) + '...' : a.title}
                  </Link>
                ))}
                <Link to="/allchinabuy-spreadsheet-guide" className="block text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer">View all articles →</Link>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">&copy; {new Date().getFullYear()} AllChinaBuy Spreadsheet. All rights reserved.</p>
            <div className="flex items-center gap-5">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">Main Site</a>
              <Link to="/allchinabuy-spreadsheet-guide" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">Guide</Link>
              <Link to="/" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">Home</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}